(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/play/assets/javascripts/views/payfooter.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/play/assets/javascripts/views/payfooter.js');

'use strict';

svs.eurojackpot.components.play.views.Payfooter = Marionette.View.extend({
  className: 'numbergames-payfooter',
  regions: {
    payfooterRegion: '#payfooterRegion'
  },
  template() {
    return '<div id="payfooterRegion"></div>';
  },
  onRender() {
    const BETSLIP_COMPLETE = svs.numbergames.game.analytics_events.BETSLIP_COMPLETE;
    const PayfooterView = svs.core.config.data.svsconfig.isSelfService ? svs.numbergames.game.views.PayFooterSelfservice : svs.numbergames.game.views.PayFooterOnline;
    this.showChildView('payfooterRegion', new PayfooterView({
      model: this.model,
      analyticsEvents: [BETSLIP_COMPLETE]
    }));
  }
});

 })(window);